import { Flex, Box } from "theme-ui";
import { Sideline } from "components/type";
import StarBurst from "components/star-burst";
import Wave from "components/svgs/wave";
import * as React from 'react';
export default {
  Flex,
  Box,
  Sideline,
  StarBurst,
  Wave,
  React
};